import React, { useState, useEffect } from "react";
import { Button } from "flowbite-react";
import axios from "axios";
import { toast } from "react-toastify";
import LoadingOverlay from "../LoadingOverlay";
import ConfirmDialog from "../ConfirmDialog";

function MaterialLocationModal({ dataSet, onClose, refreshData }) {
  const [locationId, setLocationId] = useState("");
  const [locationName, setLocationName] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [uploadPending, setUploadPending] = useState(false);

  useEffect(() => {
    if (dataSet) {
      setLocationName(dataSet.product_location_name);
      setLocationId(dataSet.product_location_id);
    }
  }, [dataSet]);

  const updateGroup = async (e) => {
    try {
      setIsLoading(true);
      const response = await axios.patch(
        `https://eps.elkomprintama.com/patch/api/store/store/material_location`,
        {
          product_location_name: locationName.toLocaleUpperCase(),
          product_location_id: locationId,
        },
      );
      if (response.status === 200) {
        // Access the 'msg' property from the response data
        toast.success(response.data.msg); // This will display the success message
        setLocationId("");
        setLocationName("");
        onClose();
        refreshData();
      }
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.msg);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleLocationNameChange = (e) => {
    setLocationName(e.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!locationName) {
      toast.warning("Please fill in all required fields");
      return;
    }
    setUploadPending(true);
    setShowConfirm(true);
  };

  return (
    <div className="relative max-w-3xl w-full bg-gray-100 p-6 rounded-lg shadow-md">
      <form className="space-y-6" onSubmit={handleSubmit}>
        <div className="flex gap-4">
          <div className="w-24">
            <label
              htmlFor="location_id"
              className="block text-sm font-medium text-gray-700 uppercase"
            >
              Location ID
            </label>
            <input
              id="location_id"
              name="location_id"
              placeholder="1"
              value={locationId}
              disabled
              className="mt-1 block w-full uppercase text-gray-400 border border-green-400 bg-white rounded-md px-3 py-2 shadow-sm focus:outline-none focus:ring-1 focus:ring-green-500"
            />
          </div>

          <div className="flex-1">
            <label
              htmlFor="group_name"
              className="block text-sm font-medium text-gray-700 uppercase"
            >
              Location Name
            </label>
            <input
              id="location_name"
              name="location_name"
              type="text"
              placeholder="Location Name"
              value={locationName}
              onChange={handleLocationNameChange}
              className="mt-1 block w-full uppercase border border-green-400 bg-white rounded-md px-3 py-2 shadow-sm focus:outline-none focus:ring-1 focus:ring-green-500"
            />
          </div>
        </div>

        <div className="w-full space-y-3">
          <Button fullSized type="submit" color="blue">
            Update
          </Button>
          <Button
            fullSized
            onClick={onClose}
            className="bg-red-600 hover:bg-red-700 text-white"
          >
            Close
          </Button>
        </div>
        {isLoading && <LoadingOverlay message="loading..." />}
        {showConfirm && uploadPending && (
          <ConfirmDialog
            message="Are you sure you want to insert the data?"
            onConfirm={() => {
              setShowConfirm(false);
              updateGroup();
            }}
            onCancel={() => {
              setShowConfirm(false);
              setUploadPending(false);
            }}
          />
        )}
      </form>
    </div>
  );
}

export default MaterialLocationModal;
